import { z } from 'zod';

export const subscriptionPeriodSchema = z.enum(['day', 'week', 'month', 'days', 'weeks', 'months']);

export type SubscriptionPeriod = z.infer<typeof subscriptionPeriodSchema>;
